// İSG Portal — dil paketi + aktif dil yükleyicileri (backend'den).
//
// Her iki uç da PUBLIC'tir (api-contract §6.1/§6.2 — `IsPublic`), login öncesi
// çalışır. `auth: false` → token/refresh devreye girmez.

import { api } from '../api/client';
import type { LanguageDto, ResourcePackDto } from './types';

/** Aktif dilleri çeker — api-contract §6.2 (`GET /languages`). */
export function fetchLanguages(): Promise<LanguageDto[]> {
  return api.get<LanguageDto[]>('languages', { auth: false });
}

/**
 * Bir kültürün dil paketini çeker — api-contract §6.1 (`GET /resources?culture=`).
 * `culture` verilmezse sunucu istek bağlamından çözer; yanıt gerçekte çözülen
 * kültürü taşır.
 */
export function fetchResources(culture?: string): Promise<ResourcePackDto> {
  return api.get<ResourcePackDto>('resources', {
    auth: false,
    searchParams: culture ? { culture } : undefined,
  });
}
